import { useOnClickOutside } from 'hooks/useOnClickOutside'
import React, { useCallback, useRef, useState } from 'react'
import styled from 'styled-components'
import Popover, { PopoverProps } from '../Popover'

const TooltipContainer = styled.div`
  max-width: 228px;
  padding: 10px 20px;
  line-height: 150%;
  font-weight: 400;
  font-size: 14px;
`

interface TooltipProps extends Omit<PopoverProps, 'content'> {
  text: React.ReactNode
}

export default function Tooltip({ text, ...rest }: TooltipProps) {
  return <Popover content={<TooltipContainer>{text}</TooltipContainer>} {...rest} />
}

export function MouseoverTooltip({ children, ...rest }: Omit<TooltipProps, 'show'>) {
  const [show, setShow] = useState(false)
  const open = useCallback(() => setShow(true), [setShow])
  const close = useCallback(() => setShow(false), [setShow])
  return (
    <Tooltip {...rest} show={show}>
      <div onMouseEnter={open} onMouseLeave={close}>
        {children}
      </div>
    </Tooltip>
  )
}

export function ClickTooltip({ children, ...rest }: Omit<TooltipProps, 'show'>) {
  const [show, setShow] = useState(false)
  const open = useCallback(
    (e) => {
      e.stopPropagation()
      setShow(true)
    },
    [setShow]
  )
  const close = useCallback(() => setShow(false), [setShow])

  const tooltipTriggerRef = useRef<HTMLDivElement | null>(null)

  useOnClickOutside(tooltipTriggerRef, show ? close : undefined)

  return (
    <Tooltip {...rest} show={show}>
      <div ref={tooltipTriggerRef} onClick={open}>
        {children}
      </div>
    </Tooltip>
  )
}
